export default __webpack_public_path__ + "static/Wix-6a797abe7280bd219eeeee132b022a26.png";